export const LOGIN_INFO = 'loginInfo';

export const USER_INFO = 'userInfo';

export const NORMAL_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const NORMAL_MINUTE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';

export const NORMAL_DAY_FORMAT = 'YYYY-MM-DD';

export const TYPE_PDF = 'application/pdf';

export const TYPE_IMAGES = 'image/*';

export const TYPE_WORD = [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-word',
    'application/msword',
];

export const TYPE_EXCEL = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
];

export const TYPE_ZIP = [
    'application/zip',
    'application/x-gzip',
    'application/x-tar',
    'application/x-7z-compressed',
    'application/x-rar-compressed',
];

// export const AREA_MAX_LENGTH = 500;
export const AREA_MAX_LENGTH = 250;

export const TEXT_MAX_LENGTH = 50;

export const SUPPLIER_NAME_MAX_LENGTH = 100;

// 采购分类值
export enum MATERIAL_CATEGORY_VALUE {
    E = 'E',
    S = 'S',
    M = 'M',
    R = 'R',
    V = 'V',
}

// 附件上传大小
export const MAX_FILE_SIZE = 300 * 1024 * 1024;
